import { assert_not_null } from '@shared/asserts/utils_asserts';

// Extending the Window interface with cursor management
declare global {
  interface HTMLCanvasElement {
    convert_to_blob: () => Promise<Blob>;
  }
}

// Keep existing window extensions
HTMLCanvasElement.prototype.convert_to_blob = convert_to_blob;

async function convert_to_blob(this: HTMLCanvasElement): Promise<Blob> {
  let mimetype = 'image/webp';

  const blob = await new Promise<Blob | null>(resolve => {
    this.toBlob(result => resolve(result), mimetype, 1.0);
  });

  assert_not_null(blob);

  return blob;
}

export {}; // Ensure this file is treated as a module
